import React from 'react';
import { XIcon, LayersIcon, PackageIcon } from 'lucide-react';
interface SelectedItemsListProps {
  selectedProducts: any[];
  selectedSKUs: any[];
  onRemoveProduct: (productId: string) => void;
  onRemoveSKU: (skuId: string) => void;
}
export const SelectedItemsList: React.FC<SelectedItemsListProps> = ({
  selectedProducts,
  selectedSKUs,
  onRemoveProduct,
  onRemoveSKU
}) => {
  return <div className="space-y-2 max-h-[400px] overflow-y-auto" data-id="element-194">
      {selectedProducts.map(product => <div key={product.id} className="bg-white border border-blue-100 rounded-md p-3 flex items-center" data-id="element-195">
          <div className="h-10 w-10 flex-shrink-0 bg-blue-50 rounded flex items-center justify-center mr-3" data-id="element-196">
            <img src={product.image} alt={product.name} className="max-h-8 max-w-8 object-contain" data-id="element-197" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-198">
            <h4 className="font-medium text-gray-800 truncate" data-id="element-199">
              {product.name}
            </h4>
            <div className="flex items-center text-xs text-gray-500" data-id="element-200">
              <LayersIcon className="h-3 w-3 mr-1 text-blue-500" data-id="element-201" />
              <span data-id="element-202">{product.variants.length} variants</span>
            </div>
          </div>
          <button onClick={() => onRemoveProduct(product.id)} className="ml-2 text-gray-400 hover:text-red-500" aria-label="Remove" data-id="element-203">
            <XIcon className="h-5 w-5" data-id="element-204" />
          </button>
        </div>)}
      {selectedSKUs.map(sku => <div key={sku.id} className="bg-white border border-green-100 rounded-md p-3 flex items-center" data-id="element-205">
          <div className="h-10 w-10 flex-shrink-0 bg-green-50 rounded flex items-center justify-center mr-3" data-id="element-206">
            <img src={sku.image} alt={sku.name} className="max-h-8 max-w-8 object-contain" data-id="element-207" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-208">
            <h4 className="font-medium text-gray-800 truncate" data-id="element-209">{sku.name}</h4>
            <div className="flex items-center text-xs text-gray-500" data-id="element-210">
              <PackageIcon className="h-3 w-3 mr-1 text-green-500" data-id="element-211" />
              <span data-id="element-212">SKU: {sku.sku}</span>
            </div>
          </div>
          <button onClick={() => onRemoveSKU(sku.id)} className="ml-2 text-gray-400 hover:text-red-500" aria-label="Remove" data-id="element-213">
            <XIcon className="h-5 w-5" data-id="element-214" />
          </button>
        </div>)}
    </div>;
};